import AuthService from "../../utilities/services/auth.service";
import { AnalyticsWrapper } from "../../components";

export default function AnalyticsPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <>
      <AnalyticsWrapper organization={organization} />
    </>
  );
}
